import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import {Col, Row} from "reactstrap";
import classNames from "classnames";

interface Props {
    period: number;
    switchToHistory: () => void;
    switchToCurrentOffer: () => void;
    switchToNextOffer: () => void;
}

export default class CustomerOfferPeriodSwitcherTabs extends Component<Props> {
    render(): JSX.Element {
        return (
            <div className="period-controls-tabs-wrapper d-none d-md-block">
                <Row className="period-controls-tabs">
                    <Col onClick={this.props.switchToHistory}>
                        <div className={classNames({active: this.props.period < 0, tab: true})}>
                            <FormattedMessage id="rewards.previous_title"/>
                        </div>
                    </Col>

                    <Col onClick={this.props.switchToCurrentOffer}>
                        <div className={classNames({active: this.props.period === 0, tab: true})}>
                            <FormattedMessage id="rewards.current_title"/>
                        </div>
                    </Col>

                    <Col onClick={this.props.switchToNextOffer}>
                        <div className={classNames({active: this.props.period > 0, tab: true})}>
                            <FormattedMessage id="rewards.upcoming_title"/>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}